import { useNavigate } from "react-router-dom";

import { Div, Image } from "@components/Generics.react";
import "@styles/components.scss";
import { settings } from "@config/settings/app.settings";
import { gradient } from "@utilities/helpers";

import { clientAssetsPath } from "../config/api/apiV6";
import CompletionIcon from "./CompletionIcon.react";

export default function CategoryCard(props) {
    const { category, completion } = props;
    const navigate = useNavigate();
    const isPortrait = window.innerHeight > window.innerWidth;
    const imageExtensions = ["png", "jpeg", "jpg"];
    const extension = category.image.split(".").pop().toLowerCase();
    const imageUrl = `${clientAssetsPath}/uploads/images/program/${category._id}.${extension}`;
    // ========================= Render Function =================================
    return (
        <Div
            className="category-card"
            rounded
            smoke
            slightShadow
            noOverflow
            clickable
            onClick={() => navigate(`/programs/${category._id}`)}
        >
            <Image
                // src={`https://www.loremflickr.com/256/128/ai?random=${Math.random()}`}
                src={
                    !imageExtensions.includes(extension)
                        ? "/assets/images/configurable/missing.jpg"
                        : imageUrl
                }
            />
            <Div
                className="card-content"
                style={{
                    background: gradient(settings.colors.primary),
                    color: settings.colors.primaryText,
                }}
            >
                <Div padded big>
                    {category.name}
                </Div>
                <Div className="category-progress-radial">
                    <CompletionIcon
                        completed={completion === 100}
                        percentage={completion}
                        size={isPortrait ? 20 : 30}
                    />
                </Div>
            </Div>
        </Div>
    );
}
